module.exports = __webpack_public_path__ + "media/images/svg/pen-6f2cdb0cb8fd25b85f401c09e5caf0e7.svg";